import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import useReveal from "./hooks/useReveal";
import KMHeader from "./components/km/KMHeader";
import { Footer } from "./components/km/Sections";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import BuyerGuidePage from "./pages/BuyerGuidePage";
import CulturePage from "./pages/CulturePage";
import ConnectDialog from "./components/km/ConnectDialog";
import QuickContact from "./components/km/QuickContact";

function Shell() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [interest, setInterest] = useState("");
  // Every "connect" CTA opens the "Let's connect." popup (optionally pre-selecting an interest)
  const connect = (i = "") => { setInterest(i); setOpen(true); };
  const ref = useReveal();
  return (
    <div className="App km-root" ref={ref} key={pathname}>
      <KMHeader onConnect={() => connect()} />
      <Routes>
        <Route path="/" element={<HomePage onConnect={connect} />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/buyers-blueprint" element={<BuyerGuidePage />} />
        <Route path="/whats-good" element={<CulturePage />} />
        <Route path="/builders" element={<Navigate to="/#builders" replace />} />
        <Route path="/culture-calendar" element={<Navigate to="/whats-good" replace />} />
        <Route path="/buyers-guide" element={<Navigate to="/buyers-blueprint" replace />} />
        <Route path="*" element={<HomePage onConnect={connect} />} />
      </Routes>
      <Footer onConnect={connect} />
      <QuickContact />
      <ConnectDialog open={open} onOpenChange={setOpen} interest={interest} />
      <Toaster position="top-center" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
